import { render, staticRenderFns } from "./work-menu.vue?vue&type=template&id=e2f1d886&scoped=true"
import script from "./work-menu.vue?vue&type=script&lang=ts"
export * from "./work-menu.vue?vue&type=script&lang=ts"
import style0 from "./work-menu.vue?vue&type=style&index=0&id=e2f1d886&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f1d886",
  null
  
)

export default component.exports